import type { ReservationPolicy } from '@wineryxplorer/shared';

const ALL: { value: ReservationPolicy; label: string }[] = [
  { value: 'required', label: 'Reservation' },
  { value: 'recommended', label: 'Recommended' },
  { value: 'drop-ins-welcome', label: 'Drop-ins' },
];

interface ReservationPolicyToggleProps {
  value: ReservationPolicy[] | undefined;
  onChange: (next: ReservationPolicy[] | undefined) => void;
}

export const ReservationPolicyToggle = ({ value, onChange }: ReservationPolicyToggleProps) => {
  const selected = value ?? [];

  const toggle = (policy: ReservationPolicy) => {
    const has = selected.includes(policy);
    const next = has ? selected.filter((p) => p !== policy) : [...selected, policy];
    onChange(next.length === 0 ? undefined : next);
  };

  return (
    <div className="inline-flex items-center gap-1 px-1 py-1 rounded-full bg-gray-50 border border-gray-200">
      {ALL.map((p) => {
        const isSelected = selected.includes(p.value);
        return (
          <button
            key={p.value}
            onClick={() => toggle(p.value)}
            aria-pressed={isSelected}
            className={`text-xs font-sans tracking-widest uppercase px-3 py-1 rounded-full transition-colors ${
              isSelected
                ? p.value === 'required'
                  ? 'bg-secondary-700 text-white'
                  : 'bg-primary-700 text-white'
                : 'text-gray-500 hover:text-gray-700'
            }`}
          >
            {p.label}
          </button>
        );
      })}
    </div>
  );
};
